var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-hover"},[_c('div',{staticClass:"icon-wrapper",class:_vm.name},[_c('base-svg',{attrs:{"name":_vm.name}})],1),_c('div',{staticClass:"text-wrapper"},[_c('base-font',{staticClass:"text-content",attrs:{"tag":"span","size":"xs","weight":"regular","uppercase":""}},[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }